import { HomeIcon, CloudIcon, RegistryIcon } from '@tanium/react-graphics';
import { useTranslation } from 'react-i18next';
import { SideNavItem, SideNavType } from '../types';
import { useTaniumInstances } from '../../../hooks/useTaniumInstances';
import { useHasPermissions } from '../../../hooks/useUserPermissions';
import { ComplianceFramework } from '../../../types';
import { useComplianceFramework } from '../../../hooks/useComplianceFramework';
import { Permission } from '../../../models/Permissions';

export const useSharedNavNavItems = (): SideNavItem[] => {
  const { t } = useTranslation();
  const { linkedTaniumInstances } = useTaniumInstances();
  const hasCloudInstances = linkedTaniumInstances?.find((i) => i.isCloudInstance);
  const canAccessArtifacts = useHasPermissions([Permission.AccessArtifacts]);
  const complianceFramework = useComplianceFramework();

  const sideNavItems: SideNavItem[] = [
    {
      type: SideNavType.Home,
      label: t('Account Management'),
      icon: HomeIcon,
      href: '/',
    },
  ];

  if (hasCloudInstances) {
    sideNavItems.push({
      type: SideNavType.Cloud,
      label: t('Cloud Instances'),
      icon: CloudIcon,
      href: '/instance/overview',
    });
  }

  if (canAccessArtifacts && complianceFramework !== ComplianceFramework.USGov) {
    sideNavItems.push({
      type: SideNavType.Artifacts,
      label: t('Artifacts'),
      icon: RegistryIcon,
      href: '/artifacts/overview',
    });
  }

  return sideNavItems;
};
